import type { LucideIcon } from 'lucide-react';
import type { GlobalSearchResult, SearchEntityType } from '@/types';

export type ActionCategory = 'navigation' | 'action' | 'theme' | 'utility';

export interface StaticAction {
  category: ActionCategory;
  icon: LucideIcon;
  id: string;
  keywords: string[];
  label: string;
  url?: string;
  action?: string;
}

export type EntityType = SearchEntityType;
export type SearchResult = GlobalSearchResult;

export interface RecentItem {
  id: string;
  name: string;
  secondary?: string;
  type: EntityType;
  url: string;
  visitedAt: number;
}

export const CATEGORY_LABELS: Record<ActionCategory, string> = {
  navigation: 'Navigation',
  action: 'Quick Actions',
  theme: 'Appearance',
  utility: 'Account',
};

export const ENTITY_LABELS: Record<EntityType, string> = {
  product: 'Products',
  variant: 'Variants',
  order: 'Orders',
  customer: 'Customers',
  inventory: 'Inventory',
  sync_event: 'Sync history',
};
